<template>  
  <div class="toggle-switch" @click.stop="toggle" :class="{ 'disabled': disabled, active: modelValue }">  
    <div class="toggle-switch-inner" :class="{ 'active': modelValue }"></div>  
  </div>  
</template>  

<script lang="ts" setup>  
import { defineProps, defineEmits } from 'vue';  

const props = defineProps<{  
  modelValue: boolean;  
  disabled?: boolean;  
}>();  

const emit = defineEmits<{  
  (e: 'update:modelValue', value: boolean): void;  
}>();  

const toggle = () => {  
  if (!props.disabled) {  
    emit('update:modelValue', !props.modelValue);  
  }  
};  
</script>  

<style scoped>  
.toggle-switch {  
  width: 28px;  
  height: 18px;  
  background-color: #747474;  
  border-radius: 500px;  
  position: relative;  
  cursor: pointer;  
  transition: background-color 0.2s ease;  
}  

.toggle-switch-inner {  
  width: 16px;  
  height: 16px;  
  background-color: white;  
  border-radius: 50%;  
  border:1px solid #747474;
  position: absolute;  
  top: 1px;  
  left: 1px;  
  transition: transform 0.2s ease;  
}  

.toggle-switch-inner.active {  
  transform: translateX(10px);  
  border: 1px solid #8DCA35;
}  

.toggle-switch.active {  
  background-color: #8DCA35;  
}  

.toggle-switch.disabled {  
  cursor: default;  
  opacity: 0.5; /* Уменьшаем непрозрачность для отключенного состояния */  
}  
</style>
